import "./polyfills";
import "./App.tsx";
import SmoothScroll from "smooth-scroll";
import { SiteData } from "./constants/types";

declare global {
    interface Window {
        siteData: SiteData;
        addthis?: {
            layers?: {
                refresh?: () => void;
            };
        };
        REGION_REMEMBER_LOCAL_STORAGE_KEY: string;
    }
    
    interface WindowEventMap {
        beforeinstallprompt: BeforeInstallPromptEvent;
    }

    interface Navigator {
        standalone?: boolean;
    }
}

window.addEventListener("DOMContentLoaded", () => {
    new SmoothScroll('a[href^="#"]', {
        speed: 500,
        offset: window.innerWidth < 768 ? 100 : 25,
    });
}); 

if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .register("/service-worker.js", { scope: "/" })
        .then(() => {
            console.log("Service worker registered");
        })
        .catch(e => {
            console.error("Service worker not registered", e);
        });
}
